'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconLinkCancel, iconLinkCancelTag } from '@ni/nimble-components/dist/esm/icons/link-cancel';
import { wrap } from '../../utilities/react-wrapper';

export type { IconLinkCancel };
export { iconLinkCancelTag };
export const NimbleIconLinkCancel = wrap(IconLinkCancel);